<template>
  <transition :name="ns.b('fade')">
    <div
      v-show="visible"
      :class="[
        ns.b(),
        ns.m(type),
        ns.is('center', center),
        ns.is(effect),
        ns.is('border', border),
        ns.m(size),
        ns.is('closable', closable),
      ]"
      role="alert"
      v-bind="
        !closable
          ? {
              'data-component-name': 'Alert',
              'data-event-container': '',
            }
          : {}
      "
    >
      <div
        v-if="showIcon && iconComponent"
        :class="[
          ns.e('icon-content'),
          ns.is('big', !!props.description || !!slots.default),
        ]"
      >
        <jd-icon :class="iconClass">
          <component :is="iconComponent" />
        </jd-icon>
      </div>

      <div :class="ns.e('content')">
        <span
          v-if="title || $slots.title"
          :class="[ns.e('title'), isBoldTitle]"
        >
          <slot name="title">{{ title }}</slot>
        </span>
        <p v-if="$slots.default || description" :class="ns.e('description')">
          <slot>
            {{ description }}
          </slot>
        </p>
        <template v-if="closable">
          <div
            v-if="closeText"
            :class="[ns.e('close-btn'), ns.is('customed')]"
            data-component-name="Alert"
            data-event-name="close"
            data-event-content="关闭提示框"
            @click="close"
          >
            {{ closeText }}
          </div>
          <jd-icon
            v-else
            :class="ns.e('close-btn')"
            data-component-name="Alert"
            data-event-name="close"
            data-event-content="关闭提示框"
            @click="close"
          >
            <Close />
          </jd-icon>
        </template>
      </div>
    </div>
  </transition>
</template>
<script lang="ts" setup>
import { computed, ref, useSlots } from 'vue'
import { JdIcon } from '@jdesign-vue/components/icon'
import { TypeComponents, TypeComponentsMap } from '@jdesign-vue/utils'
import { useNamespace } from '@jdesign-vue/hooks'
import { alertEmits, alertProps } from './alert'

const { Close } = TypeComponents

defineOptions({
  name: 'JdAlert',
})

const props = defineProps(alertProps)
const emit = defineEmits(alertEmits)
const slots = useSlots()

const ns = useNamespace('alert')

const visible = ref(true)

const iconComponent = computed(() => TypeComponentsMap[props.type])

const iconClass = computed(() => [
  ns.e('icon'),
  { [ns.is('big')]: !!props.description || !!slots.default },
])

const isBoldTitle = computed(() =>
  ns.is('bold', !!props.description || !!slots.default)
)

const close = (evt: MouseEvent) => {
  visible.value = false
  emit('close', evt)
}
</script>
